import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './UsersUIHelpers';

const UsersUIContext = createContext();

export function useUsersUIContext () {
    return useContext(UsersUIContext);
}

export const UsersUIConsumer = UsersUIContext.User;

export function UsersUIProvider ({ usersUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const user = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        user
    };

    return <UsersUIContext.Provider value={value}>{children}</UsersUIContext.Provider>;
}
